import { matchRoutes } from 'react-router-config';

import routes from '../routes';
import config from '../config';

const isClp = () => {
  const matchedRoutes = matchRoutes(routes, window.location.pathname);
  const currentRoute = matchedRoutes[0].match;

  if (currentRoute.path === '/c/:link' || currentRoute.path === '/:id') {
    return true;
  }
  return false;
};

export const shouldPreventCustomDomainAccess = () => {
  const currentDomain = window.location.host;
  if (config.baseAppDomain) {
    const isCustomDomain = currentDomain !== config.baseAppDomain;

    if (isCustomDomain && !isClp()) {
      return true;
    }
  }
  return false;
};

export const getBaseCampaignUrl = (customDomain) => {
  if (!config?.subdomainBaseUrl || !customDomain) {
    return window.location.host;
  }

  return `${customDomain}.${config.subdomainBaseUrl}`;
};

export const shouldPreventCustomDomainClpAccess = (campaignCustomDomain) => {
  const currentDomain = window.location.host;
  if (config.baseAppDomain) {
    const isCustomDomain = currentDomain !== config.baseAppDomain;
    if (isCustomDomain) {
      if (campaignCustomDomain !== currentDomain.split('.')[0]) {
        window.location.href = `https://${config.baseAppDomain}${window.location.pathname}`;
        return true;
      }
    }
  }
  return false;
};

const redirectToAllowedSubdomain = () => {
  window.location.href = `https://${config.baseAppDomain}${window.location.pathname}`;
};

export const preventCustomDomainAccess = () => {
  if (shouldPreventCustomDomainAccess()) {
    redirectToAllowedSubdomain();
  }
};

export const preventCustomDomainClpAccess = (clpCustomDomain) => {
  if (shouldPreventCustomDomainClpAccess(clpCustomDomain)) {
    redirectToAllowedSubdomain();
  }
};



// WEBPACK FOOTER //
// ./src/helpers/customDomainsHelper.js